export default __webpack_public_path__ + "static/media/daniel.33e89c2c.jpg";